import OrderPaymentHistoryItem from "@/api/OrderPaymentHistoryItem";

export class OrderPaymentDTO {
    public methodId?: string;
    public methodTitle?: string;
    public methodTitleExtra?: string;
    public paidAmount = 0;
    public onlineAmount = 0;
    public depositAmount = 0;
    public cashAmount = 0;
    public history?: OrderPaymentHistoryItem[];
}

export default class OrderPayment extends OrderPaymentDTO {
    constructor(dto: OrderPaymentDTO) {
        super();
        Object.assign(this, dto);
    }
}